import React from 'react';
import { ReactSVG } from 'react-svg';

import './style.sass';

import backArrowIcon from 'assets/img/icons/arrow-left.svg';
import { Link } from 'react-router-dom';

type Props = {
    to: string,
};

export const BackButton = ({ to }: Props) => {
    return (
        <Link to={to} className="btn-back">
            <ReactSVG src={backArrowIcon}/>
        </Link>
    );
};
